import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Overline, Reveal } from "@/components/Reveal";
import { COMMITMENTS } from "@/data/campaign";

const Commitments = () => (
  <main data-testid="commitments-page" className="pt-28 lg:pt-32">
    <section className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal>
        <Overline>My Commitments to Ward 11</Overline>
        <h1 className="mt-4 max-w-3xl font-serif text-4xl font-medium leading-[1.08] tracking-tight sm:text-5xl lg:text-6xl">
          Practical priorities. <span className="italic text-terra-500">Clear accountability.</span>
        </h1>
        <p className="mt-6 max-w-2xl text-base leading-relaxed text-ink/75 sm:text-lg">
          Six commitments, written plainly and meant to be measured. Each one comes with specific actions — and an open
          invitation to hold me to them.
        </p>
      </Reveal>

      <div className="mt-16 border-t border-pine-700/15">
        {COMMITMENTS.map((c, i) => (
          <Reveal key={c.slug} delay={0.03}>
            <Link
              to={`/commitments/${c.slug}`}
              data-testid={`commitment-row-${c.number}`}
              className="group grid items-center gap-4 border-b border-pine-700/15 py-10 transition-colors sm:grid-cols-[90px_1fr_auto] sm:gap-8 hover:bg-parch/60"
            >
              <span className="font-mono text-sm font-semibold text-terra-500 sm:pl-2">{c.number}</span>
              <div>
                <h2 className="font-serif text-2xl font-medium tracking-tight transition-colors group-hover:text-terra-500 sm:text-3xl">
                  {c.title}
                </h2>
                <p className="mt-2 max-w-2xl text-sm leading-relaxed text-ink/70 sm:text-base">{c.short}</p>
              </div>
              <span className="flex h-12 w-12 items-center justify-center border border-pine-700/20 transition-all group-hover:border-terra-500 group-hover:bg-terra-500 group-hover:text-paper sm:mr-2">
                <ArrowUpRight className="h-5 w-5" />
              </span>
            </Link>
          </Reveal>
        ))}
      </div>

      <Reveal className="my-20 bg-pine-900 p-10 text-center text-paper sm:p-14">
        <Overline light>Hold Me To It</Overline>
        <h2 className="mx-auto mt-4 max-w-2xl font-serif text-2xl font-medium leading-snug sm:text-3xl">
          Tell me what matters most on your street — and keep asking whether I delivered.
        </h2>
        <Link
          to="/get-involved?tab=priority"
          data-testid="commitments-priority-cta"
          className="mt-8 inline-block bg-terra-500 px-8 py-4 text-sm font-semibold text-paper transition-colors hover:bg-terra-600"
        >
          Share Your Priority
        </Link>
      </Reveal>
    </section>
  </main>
);

export default Commitments;
